import { Box, Tab, Tabs } from 'opensolar-ui'
import React from 'react'

interface EnergyFlowDiagramProps {
  country_iso2?: string
  solarkW?: number
  batteryKwh?: number
  showBlackoutEvenWithoutBattery?: boolean
  isCommercial?: boolean
  myeStyles: {
    highlightColor: string
    textColorOnHighlight: string
  }
  translate: (key: string) => string
}

interface EnergyFlowDiagramState {
  selectedScenarioIndex: number
}
const scenariosByCountry = {
  OTHER: [
    {
      index: 0,
      title: 'Generating Excess Solar',
      requireBattery: false,
      flows: {
        h: 'forward',
        v: '',
        tl: 'reverse',
        tr: '',
        bl: 'reverse',
        br: '',
      },
      components: {
        home: true,
        grid: true,
        solar: true,
        battery: true,
      },
    },
    {
      index: 1,
      title: 'Partially Offset Usage',
      requireBattery: false,
      flows: {
        h: '',
        v: 'reverse',
        tl: 'reverse',
        tr: 'reverse',
        bl: '',
        br: '',
      },
      components: {
        home: true,
        grid: true,
        solar: true,
        battery: true,
      },
    },
    {
      index: 2,
      title: 'Night',
      requireBattery: false,
      flows: {
        h: '',
        v: 'reverse',
        tl: '',
        tr: 'reverse',
        bl: '',
        br: '',
      },
      components: {
        home: true,
        grid: true,
        solar: false,
        battery: true,
      },
    },
    // {
    //   index: 3,
    //   title: 'Blackout',
    //   requireBattery: true,
    //   flows: {
    //     h: '',
    //     v: 'reverse',
    //     tl: '',
    //     tr: '',
    //     bl: 'reverse',
    //     br: '',
    //   },
    //   components: {
    //     home: true,
    //     grid: false,
    //     solar: true,
    //     battery: true,
    //   },
    // },
  ],
  NZ: [
    {
      index: 0,
      title: 'Morning Off-Peak',
      requireBattery: false,
      flows: {
        h: '',
        v: '',
        tl: '',
        tr: 'reverse',
        bl: '',
        br: 'reverse',
      },
      components: {
        home: true,
        grid: true,
        solar: false,
        battery: true,
      },
    },
    {
      index: 1,
      title: 'Generating Excess Solar',
      requireBattery: false,
      flows: {
        h: 'forward',
        v: '',
        tl: 'reverse',
        tr: '',
        bl: 'reverse',
        br: '',
      },
      components: {
        home: true,
        grid: true,
        solar: true,
        battery: true,
      },
    },
    {
      index: 2,
      title: 'Partially Offset Usage',
      requireBattery: false,
      flows: {
        h: '',
        v: 'reverse',
        tl: 'reverse',
        tr: 'reverse',
        bl: '',
        br: '',
      },
      components: {
        home: true,
        grid: true,
        solar: true,
        battery: true,
      },
    },
    {
      index: 3,
      title: 'Night/Peak Times',
      requireBattery: false,
      flows: {
        h: '',
        v: 'reverse',
        tl: '',
        tr: 'reverse',
        bl: '',
        br: '',
      },
      components: {
        home: true,
        grid: true,
        solar: false,
        battery: true,
      },
    },
  ],
}

class EnergyFlowDiagram extends React.Component<EnergyFlowDiagramProps, EnergyFlowDiagramState> {
  constructor(props: EnergyFlowDiagramProps) {
    super(props)
    this.state = { selectedScenarioIndex: 0 }
  }
  render() {
    const { selectedScenarioIndex } = this.state
    var scenarios = this.props.country_iso2 === 'NZ' ? scenariosByCountry.NZ : scenariosByCountry.OTHER
    const selectedScenario = scenarios[selectedScenarioIndex]
    const solarKw = this.props.solarkW ? this.props.solarkW : 0
    const batteryKwh = this.props.batteryKwh ? this.props.batteryKwh : 0
    const hasBattery = batteryKwh > 0
    const showBlackoutEvenWithoutBattery = this.props.showBlackoutEvenWithoutBattery === true || hasBattery === true
    const { translate } = this.props

    return (
      <div>
        <Box
          className="energy-flow-tabs-wrapper"
          alignItems="center"
          display="flex"
          justifyContent="center"
          margin="12px 0px 24px 0"
        >
          <Tabs
            className="energy-flow-tabs"
            onChange={(_, newValue) => {
              this.setState({ selectedScenarioIndex: newValue })
            }}
            type="segmented"
            value={selectedScenarioIndex}
          >
            {scenarios
              .filter(
                (scenario) =>
                  hasBattery === true || scenario.requireBattery === false || showBlackoutEvenWithoutBattery === true
              )
              .map((scenario) => (
                <Tab
                  isSelected={scenario.index === selectedScenarioIndex}
                  key={scenario.index}
                  label={translate(scenario.title)}
                  value={scenario.index}
                />
              ))}
          </Tabs>
        </Box>
        <div
          style={{
            position: 'relative',
            paddingTop: 12,
            paddingBottom: 12,
            padding: '12px 0',
            border: '1px solid #f0f0f0',
          }}
        >
          <div
            style={{
              width: '100%',
              fontSize: 12,
              textAlign: 'center',
              margin: '0 0 5px 0',
            }}
          >
            <div style={{ fontWeight: 'bold' }}>
              {this.props.isCommercial ? translate('BUSINESS') : translate('HOME')}
            </div>
            <div />
          </div>

          <div
            id="energy-flow"
            style={{
              margin: 'auto',
              textAlign: 'center',
              position: 'relative',
              width: 300,
              height: 300,
            }}
          >
            <div
              style={{
                position: 'absolute',
                top: '50%',
                marginTop: 38,
                width: 60,
                left: 0,
              }}
            >
              <div style={{ fontSize: 12 }}>
                <div style={{ fontWeight: 'bold' }}>{translate('SOLAR')}</div>
                <div>{(Math.round(solarKw * 10) / 10).toLocaleString(window.locale)} kW</div>
              </div>
            </div>

            <div
              style={{
                position: 'absolute',
                top: '50%',
                marginTop: 38,
                width: 60,
                right: 0,
              }}
            >
              <div style={{ fontSize: 12 }}>
                <div style={{ fontWeight: 'bold' }}>{translate('GRID')}</div>
                <div />
              </div>
            </div>

            <svg
              id="energy-flow-lines"
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                height: 300,
                width: 300,
              }}
            >
              {/* vertical */}
              {hasBattery && (
                <line
                  className={'ec-v ' + selectedScenario.flows.v}
                  style={{
                    stroke: selectedScenario.flows.v ? this.props.myeStyles.highlightColor : undefined,
                  }}
                  x1="50%"
                  y1="0"
                  x2="50%"
                  y2="100%"
                />
              )}

              {/* horizontal */}
              <line
                className={'ec-h ' + selectedScenario.flows.h}
                style={{
                  stroke: selectedScenario.flows.h ? this.props.myeStyles.highlightColor : undefined,
                }}
                x1="0"
                y1="50%"
                x2="100%"
                y2="50%"
              />

              {/* tr */}
              <line
                className={'ec-tr ' + selectedScenario.flows.tr}
                style={{
                  stroke: selectedScenario.flows.tr ? this.props.myeStyles.highlightColor : undefined,
                }}
                x1="53%"
                y1="0%"
                x2="53%"
                y2="47%"
              />
              <line
                className={'ec-tr ' + selectedScenario.flows.tr}
                style={{
                  stroke: selectedScenario.flows.tr ? this.props.myeStyles.highlightColor : undefined,
                }}
                x1="53%"
                y1="47%"
                x2="100%"
                y2="47%"
              />

              {/* br */}
              {hasBattery && (
                <line
                  className={'ec-br ' + selectedScenario.flows.br}
                  style={{
                    stroke: selectedScenario.flows.br ? this.props.myeStyles.highlightColor : undefined,
                  }}
                  x1="53%"
                  y1="100%"
                  x2="53%"
                  y2="53%"
                />
              )}
              {hasBattery && (
                <line
                  className={'ec-br ' + selectedScenario.flows.br}
                  style={{
                    stroke: selectedScenario.flows.br ? this.props.myeStyles.highlightColor : undefined,
                  }}
                  x1="53%"
                  y1="53%"
                  x2="100%"
                  y2="53%"
                />
              )}

              {/* bl */}
              {hasBattery && (
                <line
                  className={'ec-bl ' + selectedScenario.flows.bl}
                  style={{
                    stroke: selectedScenario.flows.bl ? this.props.myeStyles.highlightColor : undefined,
                  }}
                  x1="47%"
                  y1="100%"
                  x2="47%"
                  y2="53%"
                />
              )}
              {hasBattery && (
                <line
                  className={'ec-bl ' + selectedScenario.flows.bl}
                  style={{
                    stroke: selectedScenario.flows.bl ? this.props.myeStyles.highlightColor : undefined,
                  }}
                  x1="47%"
                  y1="53%"
                  x2="0%"
                  y2="53%"
                />
              )}

              {/* tl */}
              <line
                className={'ec-tl ' + selectedScenario.flows.tl}
                style={{
                  stroke: selectedScenario.flows.tl ? this.props.myeStyles.highlightColor : undefined,
                }}
                x1="47%"
                y1="0%"
                x2="47%"
                y2="47%"
              />
              <line
                className={'ec-tl ' + selectedScenario.flows.tl}
                style={{
                  stroke: selectedScenario.flows.tl ? this.props.myeStyles.highlightColor : undefined,
                }}
                x1="47%"
                y1="47%"
                x2="0%"
                y2="47%"
              />
            </svg>

            <div
              className={'energy-component-' + (selectedScenario.components.home ? 'active' : 'inactive')}
              style={{
                width: 60,
                height: 60,
                top: 0,
                left: '50%',
                marginLeft: -30,
                position: 'absolute',
                backgroundColor: selectedScenario.components.home ? this.props.myeStyles.highlightColor : '#f0f0f0',
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill={selectedScenario.components.home ? this.props.myeStyles.textColorOnHighlight : undefined}
                width="29"
                height="30"
                viewBox="0 0 29 30"
              >
                <g fillRule="evenodd">
                  <path
                    fillRule="nonzero"
                    d="M14.1554975,19.3115118 C14.1082493,19.3115118 14.071217,19.3115118 14.0329077,19.3115118 C12.8197801,19.3115118 11.6053755,19.303748 10.3916093,19.3178641 C10.1119515,19.3206873 9.90955071,19.0468363 10.0410793,18.7165211 C10.950925,16.4297242 11.8511934,14.1393982 12.7546543,11.849778 C13.2245816,10.658385 13.6951475,9.46628617 14.1650748,8.27418737 C14.2448858,8.07232813 14.3994,7.9706927 14.5654069,8.00739438 C14.7454606,8.04903667 14.8488957,8.20290141 14.8488957,8.4287579 C14.8495342,10.0944495 14.8495342,11.7594354 14.8495342,13.4244212 C14.8495342,13.4667693 14.8495342,13.5091174 14.8495342,13.5613467 C14.8942284,13.5613467 14.9312607,13.5613467 14.96957,13.5613467 C16.1795052,13.5613467 17.3900789,13.5613467 18.6006526,13.5620525 C18.8183771,13.5620525 18.9620369,13.6566299 18.9939613,13.8521369 C19.009285,13.9460085 18.9945998,14.0603484 18.959483,14.1485736 C18.4218759,15.5241808 17.8778839,16.8976706 17.3358074,18.2711604 C16.5064112,20.3737432 15.6770149,22.4749143 14.8476187,24.5760855 C14.751207,24.8231161 14.587754,24.9219283 14.396846,24.8541713 C14.2589326,24.805471 14.1669903,24.6763093 14.1567745,24.5167982 C14.154859,24.4815081 14.1554975,24.4448064 14.1554975,24.4102222 C14.1554975,22.7558234 14.1554975,21.1014245 14.1554975,19.4477315 C14.1554975,19.4053834 14.1554975,19.3637412 14.1554975,19.3115118 Z"
                  />
                  <path
                    fillRule="nonzero"
                    d="M27.0978339,16.8622954 C27.100868,16.8617679 27.1042006,16.8611936 27.1078465,16.8605685 C27.1066568,16.8607423 27.1054316,16.8609592 27.1041731,16.8612178 L27.0978339,16.8622954 Z M27,16.5575632 C27,15.8510174 27.0068286,15.8659833 26.3560124,15.1366151 C26.1840611,14.9376584 25.8107404,14.5153288 24.3641336,12.8816744 L24.1128,12.5978432 L24.1128,12.2187276 L24.1128238,4.83282737 C24.1126222,4.85926648 24.1010483,4.81419157 24.0667855,4.76726444 C24.0003981,4.67633893 23.8713622,4.59981341 23.5790302,4.55380135 C23.4992343,4.54001317 23.3802191,4.53226589 23.2285,4.53226589 L22.9168,4.53226589 C22.7578561,4.53226589 22.6383649,4.53995195 22.5499107,4.55504468 C22.2757043,4.6003207 22.1460146,4.67758353 22.0788782,4.76870056 C22.055718,4.80013344 22.0401586,6.62876317 22.0322,10.2545897 L20.2771363,8.23341685 C19.1285423,6.91066883 17.9299873,5.5239283 16.7527276,4.15740781 C16.3406978,3.67913866 15.9607489,3.23754533 15.6217946,2.84316229 C15.4183683,2.60646989 15.2738519,2.43815802 15.1657319,2.31025871 C15.1498479,2.28978017 15.0845164,2.22224051 14.9901519,2.15237327 C14.849686,2.04837267 14.7160139,1.99665026 14.5398718,2.00018526 C14.4271695,1.99673177 14.2898545,2.04971375 14.144354,2.1560527 C14.0458755,2.22802559 13.9768083,2.2979438 13.9265089,2.35902289 C13.5721615,2.76058122 13.5721615,2.76058122 12.1547664,4.36684074 C10.3830225,6.37468014 9.49715134,7.37860884 8.25693183,8.7841368 C5.0647468,12.4018071 3.01249205,14.7278012 2.64127724,15.1489181 C1.99255544,15.8751344 2,15.8590496 2,16.5578888 C2,16.6970552 2.00875624,16.8014204 2.01924387,16.8709397 C2.23366558,16.8753191 2.73458106,16.8765651 3.40860938,16.8748629 C3.67938401,16.874179 3.96800701,16.8730639 4.26336903,16.871637 C4.57156149,16.8701481 4.82275677,16.8686594 4.97101624,16.8676685 L5.9777,16.8609399 L5.9777,26.8173967 C5.9777,27.5362387 6.17970515,27.8252471 6.57368065,27.9678473 C6.61538398,27.9826638 6.6452859,27.9929215 6.66719595,28 L22.4668215,28 C22.4893687,27.9927434 22.5226502,27.9818773 22.5728219,27.9654293 C22.9644691,27.8188279 23.1621,27.5284308 23.1621,26.8173967 L23.1621,16.8676461 L26.9809558,16.8676461 C26.9919028,16.7951989 27,16.6915432 27,16.5575632 Z M2.03722439,16.95484 C2.03970331,16.962245 2.04205331,16.9676019 2.04417442,16.9709101 C2.04337593,16.9696647 2.04256248,16.9684281 2.04173509,16.9672003 L2.03722439,16.95484 Z M27.858657,13.8168406 C28.8018879,14.8736404 29,15.3078347 29,16.5575632 C29,17.7932435 28.5209875,18.6753547 27.4772112,18.8244679 C27.3629893,18.8508208 27.2387656,18.8676461 27.1117,18.8676461 L25.1621,18.8676461 L25.1621,26.8173967 C25.1621,28.3763359 24.434581,29.4176994 23.2120512,29.860602 C22.9349611,29.9514716 22.9126203,29.9582562 22.7644027,29.9845857 L22.5895,30 L6.5506,30 L6.38261444,29.9857895 C6.21732875,29.9576236 6.10081883,29.9223233 5.89859473,29.8504584 C4.70590399,29.418817 3.9777,28.376977 3.9777,26.8173967 L3.9777,18.8729436 C3.78402351,18.8737493 3.59493164,18.8743987 3.41366024,18.8748565 C2.58097719,18.8769594 2.03872583,18.8749996 1.85491018,18.8668342 C0.590062572,18.8158323 0,17.89554 0,16.5578888 C0,15.310834 0.199050116,14.8807647 1.1453191,13.8214901 C1.51251341,13.4049012 3.56441142,11.0793115 6.75685981,7.46134266 C7.997509,6.05532775 8.8833858,5.05139263 10.6551377,3.04354422 C12.0725393,1.43727737 12.0725393,1.43727737 12.39492,1.07381415 C12.5156452,0.922455089 12.7049024,0.730866193 12.9642366,0.541331982 C13.4400892,0.193555476 13.9875495,-0.0176780621 14.5397448,0.00112746362 C15.1577884,-0.0178895648 15.7070517,0.194639532 16.180251,0.544995204 C16.4390928,0.73664115 16.6267245,0.930614663 16.7148764,1.0462503 C16.7912669,1.13529504 16.935552,1.30333746 17.1385741,1.53955957 C17.4770339,1.93336738 17.856474,2.37436925 18.2679724,2.85202171 C18.8537331,3.53195149 19.4447638,4.21688329 20.0322299,4.89637725 C20.0350092,4.4620344 20.1456877,4.02078318 20.4687452,3.58233146 C20.8505291,3.06417664 21.4441089,2.71055073 22.2186352,2.58267911 C22.4288931,2.54676642 22.6543253,2.53226589 22.9168,2.53226589 L23.2285,2.53226589 C23.4849395,2.53226589 23.7111327,2.54698991 23.9043873,2.58050309 C24.6961923,2.70480593 25.2977721,3.06157629 25.6820604,3.58790577 C26.0014037,4.02528518 26.1103399,4.46458345 26.1128,4.82444259 L26.1128,11.8396204 C27.3675302,13.2566811 27.6988951,13.6318047 27.858657,13.8168406 Z"
                  />
                </g>
              </svg>
            </div>
            <div
              className={'energy-component-' + (selectedScenario.components.solar ? 'active' : 'inactive')}
              style={{
                width: 60,
                height: 60,
                top: '50%',
                marginTop: -30,
                left: 0,
                position: 'absolute',
                backgroundColor: selectedScenario.components.solar ? this.props.myeStyles.highlightColor : '#f0f0f0',
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill={selectedScenario.components.solar ? this.props.myeStyles.textColorOnHighlight : undefined}
                width="32"
                height="32"
                viewBox="0 0 32 32"
              >
                <path
                  d="M5.54877112,0.723711613 L0.0565315669,15.6878304 C-0.185073806,16.345901 0.38328206,17.1579811 1.08632625,17.1591487 L13.9015522,17.1591487 L13.9015522,20.8089302 C12.7705015,20.8089302 11.6134976,20.8089302 10.4917869,20.8089302 C9.9174325,20.8399437 9.42284811,21.3882629 9.45276434,21.9608091 C9.4826813,22.5333554 10.0317307,23.0274556 10.6062085,22.9988137 L19.393792,22.9988137 C19.9728602,23.0050164 20.5040418,22.4811067 20.5040418,21.9038902 C20.5040418,21.3266737 19.9728602,20.8028005 19.393792,20.8089302 L16.0984479,20.8089302 L16.0984479,17.1591487 L28.9136739,17.1591487 C29.6167177,17.1591487 30.1850737,16.345901 29.9434685,15.6878304 L24.451229,0.723697019 C24.2941628,0.310348709 23.8648753,0.015559646 23.4214341,0.0165484303 C17.7734929,-0.0504553862 12.1022304,0.115003613 6.46414448,0.00512815443 C6.05974066,0.0586939914 5.69058828,0.343872509 5.54877112,0.723711613 Z M7.3451913,2.1950153 L10.846494,2.1950153 L10.4574604,4.74986601 L6.40693369,4.74986601 L7.3451913,2.1950153 Z M13.0662739,2.1950153 L17.6660246,2.1950153 L18.0550585,4.74986601 L12.6772407,4.74986601 L13.0662739,2.1950153 Z M19.8858049,2.1950153 L22.6548092,2.1950153 L23.5930668,4.74986601 L20.2748385,4.74986601 L19.8858049,2.1950153 Z M5.60598191,6.93975316 L10.1141956,6.93975316 L9.66795089,9.85958567 L4.53041848,9.85958567 L5.60598191,6.93975316 Z M12.3339756,6.93975316 L18.3983233,6.93975316 L18.8445677,9.85958567 L11.8877308,9.85958567 L12.3339756,6.93975316 Z M20.6181036,6.93975316 L24.3940183,6.93975316 L25.469582,9.85958567 L21.064348,9.85958567 L20.6181036,6.93975316 Z M3.7294667,12.0494327 L9.32468578,12.0494327 L8.87844141,14.9692652 L2.65390291,14.9692652 L3.7294667,12.0494327 Z M11.5444661,12.0494327 L19.1878328,12.0494327 L19.6340771,14.9692652 L11.0982217,14.9692652 L11.5444661,12.0494327 Z M21.4076131,12.0494327 L26.2705335,12.0494327 L27.3460969,14.9692652 L21.8538571,14.9692652 L21.4076131,12.0494327 Z"
                  transform="translate(1 4)"
                />
              </svg>
            </div>
            <div
              className={'energy-component-' + (selectedScenario.components.grid ? 'active' : 'inactive')}
              style={{
                width: 60,
                height: 60,
                top: '50%',
                marginTop: -30,
                right: 0,
                position: 'absolute',
                backgroundColor: selectedScenario.components.grid ? this.props.myeStyles.highlightColor : '#f0f0f0',
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill={selectedScenario.components.grid ? this.props.myeStyles.textColorOnHighlight : undefined}
                width="32"
                height="32"
                viewBox="0 0 32 32"
              >
                <path
                  d="M21.5936247,12.7320249 L14.3425143,9.01002078 L14.3425143,6.58988686 L18.1532457,6.58988686 L18.1532457,8.66460402 C18.1532457,9.07540984 18.491361,9.40863542 18.9081949,9.40863542 C19.3250288,9.40863542 19.663144,9.07577927 19.663144,8.66460402 L19.663144,6.58988686 L21.2450136,6.58988686 C21.592875,6.58988686 21.8953795,6.35566844 21.9782215,6.02281228 C22.0610634,5.68995613 21.9021268,5.34453937 21.5939996,5.18605403 L11.655585,0.08422997 C11.5480029,0.028815516 11.4284256,0 11.306974,0 L11.0715678,0 C10.9542395,0 10.8380358,0.0269683676 10.7330777,0.0790579543 L0.416438874,5.18051258 C0.103813456,5.33530363 -0.0599962656,5.68145925 0.0202217673,6.01690141 C0.100814651,6.352713 0.404818505,6.58951743 0.754928985,6.58951743 L2.33642376,6.58951743 L2.33642376,8.66423459 C2.33642376,9.07504041 2.67416417,9.40826599 3.09137291,9.40826599 C3.5082068,9.40826599 3.84632206,9.07540984 3.84632206,8.66423459 L3.84632206,6.58951743 L7.65705347,6.58951743 L7.65705347,9.14597091 L0.416813725,12.7264835 C0.104188306,12.8809051 -0.059621415,13.2270607 0.020596618,13.5628723 C0.101189502,13.8983145 0.405193355,14.1354883 0.755303835,14.1354883 L2.33679861,14.1354883 L2.33679861,16.3166012 C2.33679861,16.7270376 2.67453902,17.0606326 3.09174776,17.0606326 C3.50858165,17.0606326 3.84669691,16.7274071 3.84669691,16.3166012 L3.84669691,14.1354883 L7.20310937,14.1354883 L0.302484285,30.9774186 C0.175409924,31.2870007 0.273245937,31.6416532 0.542013832,31.8455784 C0.677709757,31.9482798 0.840020076,32 1.00270525,32 C1.16164191,32 1.32057857,31.9504964 1.45477509,31.8518587 L11.0003462,24.814223 L20.5455424,31.8518587 C20.6793641,31.9508659 20.8386756,32 20.9979871,32 C20.9987368,32 20.9994865,32 21.0002362,32 C21.4166952,32 21.7551853,31.6671438 21.7551853,31.2559686 C21.7551853,31.1373817 21.7270715,31.025075 21.6768416,30.925329 L14.7972081,14.1358578 L18.1532457,14.1358578 L18.1532457,16.3169707 C18.1532457,16.7274071 18.491361,17.0610021 18.9081949,17.0610021 C19.3250288,17.0610021 19.663144,16.7277765 19.663144,16.3169707 L19.663144,14.1358578 L21.2450136,14.1358578 C21.592875,14.1358578 21.8953795,13.9016393 21.9782215,13.5687832 C22.0606886,13.235927 21.9017519,12.8901408 21.5936247,12.7320249 Z M18.1614924,12.647795 L14.3425143,12.647795 L14.3425143,10.687601 L18.1614924,12.647795 Z M9.16657692,10.0647426 L11.1847727,9.06654352 L12.8329908,9.91253752 L12.8329908,12.647795 L9.16657692,12.647795 L9.16657692,10.0647426 Z M7.20798243,18.0968829 L8.63091539,14.623505 L9.87279549,15.7273609 L7.20798243,18.0968829 Z M10.9999713,16.7296236 L13.8199725,19.236943 L8.17997009,19.236943 L10.9999713,16.7296236 Z M14.0250158,20.7253752 L10.9999713,22.9556223 L7.9749268,20.7253752 L14.0250158,20.7253752 Z M12.1271471,15.7277303 L13.3690272,14.623505 L14.792335,18.0968829 L12.1271471,15.7277303 Z M10.9995965,14.7254676 L10.3361109,14.1354883 L11.6627072,14.1354883 L10.9995965,14.7254676 Z M14.3425143,5.10182406 L14.3425143,3.14163011 L18.1614924,5.10182406 L14.3425143,5.10182406 Z M11.1847727,1.52057262 L12.8329908,2.36656661 L12.8329908,5.10145463 L9.16657692,5.10145463 L9.16657692,2.51840222 L11.1847727,1.52057262 Z M3.94265867,5.10182406 L7.65667862,3.26538906 L7.65667862,5.10182406 L3.94265867,5.10182406 Z M9.16657692,6.58988686 L12.8329908,6.58988686 L12.8329908,8.23495728 L11.6552102,7.63057031 C11.5476281,7.57515585 11.4280507,7.54634034 11.3065991,7.54634034 L11.0711929,7.54634034 C10.9538647,7.54634034 10.837661,7.5733087 10.7327028,7.62539829 L9.16620207,8.40009236 L9.16620207,6.58988686 L9.16657692,6.58988686 Z M7.65705347,10.8109905 L7.65705347,12.647795 L3.94265867,12.647795 L7.65705347,10.8109905 Z M2.71427318,29.0645117 L5.97397418,21.1084738 L9.73972352,23.8851074 L2.71427318,29.0645117 Z M12.2602191,23.8847379 L16.0259684,21.1081044 L19.2856694,29.0641422 L12.2602191,23.8847379 Z"
                  transform="translate(5)"
                />
              </svg>
            </div>

            {hasBattery && (
              <div
                className={'energy-component-' + (selectedScenario.components.battery ? 'active' : 'inactive')}
                style={{
                  width: 60,
                  height: 60,
                  bottom: 0,
                  left: '50%',
                  marginLeft: -30,
                  position: 'absolute',
                  backgroundColor: selectedScenario.components.battery
                    ? this.props.myeStyles.highlightColor
                    : '#f0f0f0',
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                  <g
                    stroke={selectedScenario.components.battery ? this.props.myeStyles.textColorOnHighlight : undefined}
                    fill="none"
                    fillRule="evenodd"
                    transform="translate(6 1)"
                  >
                    <path
                      strokeWidth="2"
                      d="M14 28.8578169L14 1.14218306 1.86783628 2.75980489C1.37103026 2.8260457 1 3.24983017 1 3.75103279L1 26.2489672C1 26.7501698 1.37103026 27.1739543 1.86783628 27.2401951L14 28.8578169zM15 1.2198039L15 28.7801961 18 28.1801961 18 1.8198039 15 1.2198039z"
                    />
                  </g>
                </svg>
              </div>
            )}
          </div>

          {hasBattery && (
            <div
              style={{
                width: '100%',
                fontSize: 12,
                textAlign: 'center',
                margin: '8px 0 0 0',
              }}
            >
              <div style={{ fontWeight: 'bold' }}>{translate('BATTERY')}</div>
              <div>{(Math.round(batteryKwh * 10) / 10).toLocaleString(window.locale)} kWh</div>
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default EnergyFlowDiagram
